<div class="filter-row" [dir]="currentLang ? (currentLang === 'iw' ? 'rtl' : 'ltr') : 'auto'">

    <!-- Month filter chip with range picker -->
    <button class="filter-chip" [class.chip-active]="startMonth"
            [matMenuTriggerFor]="monthMenu" #monthTrigger="matMenuTrigger">
      {{ 'BILLING.MONTH' | translate }}
      @if (monthLabel) {
        <span class="chip-badge">{{ monthLabel }}</span>
      }
      <svg width="10" height="6" viewBox="0 0 10 6">
        <path d="M1 1l4 4 4-4" stroke="#485760" stroke-width="1.2" fill="none" stroke-linecap="round"/>
      </svg>
    </button>
  
    <mat-menu #monthMenu="matMenu" panelClass="month-range-panel" xPosition="after">
      <div class="month-picker" (click)="$event.stopPropagation()">
  
        <!-- Year navigation -->
        <div class="year-nav">
          <button class="nav-btn" (click)="prevYear()">
            <svg width="6" height="10" viewBox="0 0 6 10" [style.transform]="currentLang === 'iw' ? 'scaleX(-1)' : 'none'">
              <path d="M5 1L1 5l4 4" stroke="#485760" stroke-width="1.3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <span class="year-label">{{ displayYear }}</span>
          <button class="nav-btn" (click)="nextYear()">
            <svg width="6" height="10" viewBox="0 0 6 10" [style.transform]="currentLang === 'iw' ? 'scaleX(-1)' : 'none'">
              <path d="M1 1l4 4-4 4" stroke="#485760" stroke-width="1.3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
  
        <!-- Selection hint -->
        <div class="picker-hint">
          {{ selecting === 'start' ? ('BILLING.SELECT_START_MONTH' | translate) : ('BILLING.SELECT_END_MONTH' | translate) }}
        </div>
  
        <!-- Month grid (4 × 3) -->
        <div class="month-grid">
          @for (month of months; track month; let i = $index) {
            <button class="month-cell"
              [class.is-start]="isStart(i)"
              [class.is-end]="isEnd(i)"
              [class.in-range]="isInRange(i)"
              (click)="selectMonth(i)">
              {{ month }}
            </button>
          }
        </div>
  
        <!-- Footer -->
        <div class="picker-footer">
          <button class="clear-btn" (click)="clearMonthFilter($event)">{{ 'TICKET_MANAGEMENT.CLEAR' | translate }}</button>
          <button class="apply-btn" (click)="applyFilter()">{{ 'TITLES.APPLY' | translate }}</button>
        </div>
  
      </div>
    </mat-menu>
  
    <!-- Sites filter chip with hierarchy dropdown -->
    <button class="filter-chip" [class.chip-active]="selectedSiteIds.length > 0"
            [matMenuTriggerFor]="sitesMenu" #sitesTrigger="matMenuTrigger">
      {{ 'BILLING.SITES' | translate }}
      @if (sitesLabel) {
        <span class="chip-badge">{{ sitesLabel }}</span>
      }
      <svg width="10" height="6" viewBox="0 0 10 6">
        <path d="M1 1l4 4 4-4" stroke="#485760" stroke-width="1.2" fill="none" stroke-linecap="round"/>
      </svg>
    </button>
  
    <mat-menu #sitesMenu="matMenu" panelClass="sites-filter-panel" xPosition="after">
      <div class="sites-picker" (click)="$event.stopPropagation()">
  
        <!-- Search -->
        <div class="sites-search">
          <input class="sites-search-input" type="text"
                 [placeholder]="'OTHER.SEARCH' | translate"
                 (keydown)="$event.stopPropagation()"
                 (input)="filterSites($any($event.target).value)" />
        </div>
  
        <!-- Hierarchy list -->
        <div class="sites-list">
          @for (group of sitesHierarchy; track $index) {
            @if (group.display) {
  
              <!-- Parent row — only shown when the group has multiple children -->
              @if (group.names.length > 1) {
                <div class="site-row group-row">
                  <mat-checkbox
                    [checked]="isGroupSelected(group)"
                    [indeterminate]="isGroupIndeterminate(group)"
                    (change)="toggleGroup(group)"
                    (click)="$event.stopPropagation()">
                    <span class="site-name">{{ group.letter }}</span>
                  </mat-checkbox>
                </div>
              }
  
              <!-- Child sites (indented when under a parent) -->
              @for (site of group.names; track site.site_id) {
                <div class="site-row" [class.sub-row]="group.names.length > 1">
                  <mat-checkbox
                    [checked]="isSiteSelected(site)"
                    (change)="toggleSite(site)"
                    (click)="$event.stopPropagation()">
                    <span class="site-name">{{ site.site_name }}</span>
                  </mat-checkbox>
                </div>
              }
  
            }
          }
        </div>
  
        <!-- Footer -->
        <div class="picker-footer sites-footer">
          <button class="clear-btn" (click)="clearSiteFilter($event)">{{ 'TICKET_MANAGEMENT.CLEAR' | translate }}</button>
          <button class="apply-btn" (click)="applySiteFilter()">{{ 'TITLES.APPLY' | translate }}</button>
        </div>
  
      </div>
    </mat-menu>
  
    <!-- Event type filter chip -->
    <button class="filter-chip" [class.chip-active]="selectedEventTypes.length > 0"
            [matMenuTriggerFor]="eventMenu" #eventTrigger="matMenuTrigger">
      {{ 'BILLING.EVENT' | translate }}
      @if (eventTypeLabel) {
        <span class="chip-badge">{{ eventTypeLabel }}</span>
      }
      <svg width="10" height="6" viewBox="0 0 10 6">
        <path d="M1 1l4 4 4-4" stroke="#485760" stroke-width="1.2" fill="none" stroke-linecap="round"/>
      </svg>
    </button>
  
    <mat-menu #eventMenu="matMenu" panelClass="sites-filter-panel" xPosition="after">
      <div class="sites-picker" (click)="$event.stopPropagation()">
        <div class="sites-list">
          @for (type of eventTypes; track type) {
            <div class="site-row">
              <mat-checkbox
                [checked]="isEventTypeSelected(type)"
                (change)="toggleEventType(type)"
                (click)="$event.stopPropagation()">
                <span class="site-name">{{ type }}</span>
              </mat-checkbox>
            </div>
          }
        </div>
        <div class="picker-footer sites-footer">
          <button class="clear-btn" (click)="clearEventTypeFilter($event)">{{ 'TICKET_MANAGEMENT.CLEAR' | translate }}</button>
          <button class="apply-btn" (click)="applyEventTypeFilter()">{{ 'TITLES.APPLY' | translate }}</button>
        </div>
      </div>
    </mat-menu>
  
    <span class="clear-all" [class.clear-all-active]="hasAnyFilter" (click)="clearAll()">
      {{ 'BILLING.CLEAR_ALL' | translate }}
    </span>
  </div>
  